import React from 'react';
import SearchBar from 'Common/Components/SearchBar/index';
import 'Common/styles/commonStyles.scss';
import { useSelector } from 'react-redux';
import { selectPathname } from 'store/Router/selectors';
import { getShowNewSearcher } from 'Common/Components/SearchBar/routeVisibility';

const Searcher = () => {
  const pathname = useSelector(selectPathname);

  if (getShowNewSearcher(pathname)) return <SearchBar />;

  return null;
};

export default Searcher;
